// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { OnDemandCourseSessionsV1 } from './OnDemandCourseSessionsV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ProductId {
  productItemId: string;
}

export interface EnterpriseSpecializationConfiguration {
  canEditConfiguration: boolean;
  nonEditableConfigurationReason?: NonEditableConfigurationReason | null;
  s12nIdsConfiguredInProgram?: string[] | null;
  createSessionEligibility: CreateSessionEligibility;
  activeSessionsForCoursesInSpecialization: Array<EnterpriseAdminSessionSelectionOption>;
}

export interface EnterpriseProductConfigurationTypeSpecialization {
  typeName: 'specialization';
  definition: EnterpriseSpecializationConfiguration;
}

export interface EnterprisePrivateSessionGroupSelectionOption {
  sessionId: string;
  groupId: string;
  groupName: string;
  versionName: string;
}

export interface EnterpriseAdminSessionSelectionOptionTypePrivateSessionGroupOption {
  typeName: 'privateSessionGroupOption';
  definition: EnterprisePrivateSessionGroupSelectionOption;
}

export interface EnterpriseExternallyManagedSessionSelectionOption {
  sessionId: string;
  name: string;
  minNumberOfDays: number;
  maxEndDate: number;
  canEdit: boolean;
}

export interface EnterpriseAdminSessionSelectionOptionTypeExternallyManagedSessionOption {
  typeName: 'externallyManagedSessionOption';
  definition: EnterpriseExternallyManagedSessionSelectionOption;
}

export interface EnterpriseFlexibleSessionsSelectionOption {
  versionName: string;
}

export interface EnterpriseAdminSessionSelectionOptionTypeFlexibleOption {
  typeName: 'flexibleOption';
  definition: EnterpriseFlexibleSessionsSelectionOption;
}

export type EnterpriseAdminSessionSelectionOptionType =
  | EnterpriseAdminSessionSelectionOptionTypePrivateSessionGroupOption
  | EnterpriseAdminSessionSelectionOptionTypeExternallyManagedSessionOption
  | EnterpriseAdminSessionSelectionOptionTypeFlexibleOption;

export type EnterpriseAdminSessionSelectionOptionTypeTypeName =
  | 'privateSessionGroupOption'
  | 'externallyManagedSessionOption'
  | 'flexibleOption';

export interface EnterpriseAdminSessionSelectionOption {
  isSelected: boolean;
  optionType: EnterpriseAdminSessionSelectionOptionType;
  courseId: string;
}

export type IneligibleReason =
  | 'LIMITED_AVAILABILITY_COURSE'
  | 'ENTERPRISE_PRIVATE_COURSE'
  | 'CONTENT_EXPERIMENT_COURSE'
  | 'FEATURE_DISABLED'
  | 'NON_ENDED_SESSIONS_THRESHOLD_REACHED';

export interface Ineligible {
  reason: IneligibleReason;
  teachCourseLink?: string | null;
}

export interface CreateSessionEligibilityIneligible {
  typeName: 'ineligible';
  definition: Ineligible;
}

export interface EligibleForExternallyManagedSession {
  minNumberOfDays: number;
  maxEndDate: number;
}

export interface CreateSessionEligibilityEligible {
  typeName: 'eligible';
  definition: EligibleForExternallyManagedSession;
}

export type CreateSessionEligibility = CreateSessionEligibilityIneligible | CreateSessionEligibilityEligible;

export type CreateSessionEligibilityTypeName = 'ineligible' | 'eligible';

export type NonEditableConfigurationReason =
  | 'ONE_OR_MORE_COURSES_CONFIGURED_WITH_ANOTHER_S12N'
  | 'COURSE_CONFIGURED_WITH_S12N';

export interface EnterpriseCourseConfiguration {
  selectableSessions: Array<EnterpriseAdminSessionSelectionOption>;
  createSessionEligibility: CreateSessionEligibility;
  canEditConfiguration: boolean;
  nonEditableConfigurationReason?: NonEditableConfigurationReason | null;
  s12nIdsConfiguredInProgram?: string[] | null;
}

export interface EnterpriseProductConfigurationTypeCourse {
  typeName: 'course';
  definition: EnterpriseCourseConfiguration;
}

export type EnterpriseProductConfigurationType =
  | EnterpriseProductConfigurationTypeSpecialization
  | EnterpriseProductConfigurationTypeCourse;

export type EnterpriseProductConfigurationTypeTypeName = 'specialization' | 'course';

export interface EnterpriseProductConfigurationsV1 {
  id: string;
  scopeId: string;
  productId: ProductId;
  productConfigurationType: EnterpriseProductConfigurationType;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseProductConfigurationsV1Connection {
  elements: Array<EnterpriseProductConfigurationsV1> | null;
  linked: {
    onDemandCourseSessionsV1: Array<OnDemandCourseSessionsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseProductConfigurationsV1GetQuery {
  EnterpriseProductConfigurationsV1: {
    get: EnterpriseProductConfigurationsV1Connection | null;
  } | null;
}

export interface EnterpriseProductConfigurationsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseProductConfigurationsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseProductConfigurations.v1' as const;

  declare id: string;

  declare scopeId: string;

  declare productId: ProductId;

  declare productConfigurationType: EnterpriseProductConfigurationType;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseProductConfigurationsV1>) {
    super(params);
  }
}
